<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { registerToast, sessionExpired } from '@/shared/ui/notify';

// Bridge the interceptor (which runs outside any component) to PrimeVue's toast.
registerToast(useToast().add);

const {t} = useI18n();

const router = useRouter();

function goToLogin(): void {
  sessionExpired.visible = false;
  void router.push({name: 'login'});
}
</script>

<template>
  <RouterView />
  <Toast />

  <Dialog
      v-model:visible="sessionExpired.visible"
      modal
      :closable="false"
      :header="t('shared.session.expiredHeader')"
      :style="{ width: '24rem' }">
    <div class="flex items-start gap-3">
      <i class="fa-solid fa-circle-question text-2xl text-amber-500" />
      <p class="text-sm">
        {{ t('shared.session.expiredMessage') }}
      </p>
    </div>
    <template #footer>
      <Button :label="t('shared.session.toLogin')" icon="fa-solid fa-right-from-bracket" @click="goToLogin" />
    </template>
  </Dialog>
</template>
